import { observer } from 'mobx-react-lite'
import { Referrals } from 'pages/settings/pages/referrals/pages/ReferralsView/Referrals'

export const ReferralsViewPage = observer(() => {
  return <Referrals />
})
